// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__CjETo","messages":"Chat_messages__1nPcy","dateDivider":"Chat_dateDivider__1CEb-"};